import { useEffect, useMemo, useState } from "react";
import { CompanyBasic } from "../../features/companies/types";
import agent from "../api/agent";
import { getISODate } from "../helpers/dateHelpers";

type DateRange = { start: Date; end: Date } | null | undefined;

const useShadowingCompanies = (dateRange?: DateRange) => {
  const [companies, setCompanies] = useState<CompanyBasic[]>([]);
  const dateFrom = dateRange?.start ? getISODate(dateRange.start) : undefined;
  const dateTo = dateRange?.end ? getISODate(dateRange.end) : undefined;

  useEffect(() => {
    agent.ShadowingCompanies.list(dateRange ? { dateFrom, dateTo } : undefined).then(setCompanies);
  }, [dateFrom, dateTo]); // eslint-disable-line react-hooks/exhaustive-deps

  return useMemo(
    () => ({
      companies,
      companyOptions: companies.map((company) => ({ key: company.id, value: company.id, text: company.name })),
    }),
    [companies]
  );
};

export default useShadowingCompanies;
